import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import {
  ISubMenu,
  SidemenuComponent,
} from './shared/layout/sidemenu/sidemenu.component';
import { RestaurantComponent } from './components/restaurant/restaurant/restaurant.component';
import { DatesRestaurantComponent } from './components/restaurant/dates-restaurant/dates-restaurant.component';
import { MenuEditRestaurantComponent } from './components/restaurant/menu-edit-restaurant/menu-edit-restaurant.component';
import { ReservationConfigComponent } from './components/restaurant/reservation-config/reservation-config.component';
import { ShipmentConfigurationComponent } from './components/restaurant/shipment-configuration/shipment-configuration.component';
import { MailboxComponent } from './components/news/mailbox/mailbox.component';
import { EditDetailMailComponent } from './components/news/edit-detail-mail/edit-detail-mail.component';
import { IncorporationFormComponent } from './components/news/incorporation-form/incorporation-form.component';
import { UploadFilesComponent } from './shared/components/upload-files/upload-files.component';
import { ActivitiesComponent } from './components/news/activities/activities.component';
import { CommentsFormComponent } from './components/news/comments/comments.component';
import { EditDetailActivitiesComponent } from './components/news/edit-detail-activities/edit-detail-activities.component';
import { PoliciesComponent } from './components/users/policies/policies.component';
import { PolicyFormComponent } from './components/users/policy-form/policy-form.component';
import { AddMailComponent } from './components/news/add-mail/add-mail.component';
import { AddActivitiesComponent } from './components/news/add-activities/add-activities.component';
import { CultureComponent } from './components/culture/culture/culture.component';
import { CultureFormComponent } from './components/culture/culture-form/culture-form.component';
import { PricesComponent } from './components/restaurant/prices/prices.component';
import { PriceFormComponent } from './components/restaurant/price-form/price-form.component';
import { NewComponent } from './components/news/new/new.component';
import { NewsFormComponent } from './components/news/news-form/news-form.component';
import { ListUsersComponent } from './components/users/list-users/list-users.component';
import { EditUserRoleComponent } from './components/users/edit-user-role/edit-user-role.component';
import { MissionComponent } from './components/culture/mission/mission.component';
import { MissionFormComponent } from './components/culture/mission-form/mission-form.component';
import { OrganizationComponent } from './components/culture/organization/organization.component';
import { OrganizationFormComponent } from './components/culture/organization-form/organization-form.component';
import { ReservationFormComponent } from './components/restaurant/reservation-form/reservation-form.component';
import { UploadPayrollComponent } from './components/payroll/upload-payroll/upload-payroll.component';
import { CookScreenComponent } from './components/restaurant/cook-screen/cook-screen.component';
import { CookBreakfastScreenComponent } from './components/restaurant/cookbreakfast-screen/cookbreakfast-screen.component';
import { PunchesComponent } from './components/restaurant/punches/punches.component';
import { UtilsComponent } from './components/utils/utils.component';
import { DriversComponent } from './components/vacations/drivers/drivers.component';
import { ExerciseComponent } from './components/vacations/exercise/exercise.component';
import { OperationalComponent } from './components/vacations/operational/operational.component';
import { DriverProfileComponent } from './components/vacations/driver-profile/driver-profile.component';
import { ExerciseFormComponent } from './components/vacations/exercise-form/exercise-form.component';
import { ProtocolFormComponent } from './components/vacations/protocol-form/protocol-form.component';
import { RuleGroupFormComponent } from './components/vacations/rule-group-form/rule-group-form.component';
import { RuleFormComponent } from './components/vacations/rule-form/rule-form.component';
import { OperationalFormComponent } from './components/vacations/operational-form/operational-form.component';
import { ProtocolsComponent } from './components/vacations/protocols/protocols.component';
import { PriorityPeriodsComponent } from './components/vacations/priority-periods/priority-periods.component';
import { PriorityPeriodFormComponent } from './shared/components/vacations/priority-period-form/priority-period-form.component';
import { DriversvacationsComponent } from './components/vacations/driversvacations/driversvacations.component';
import { ManagementComponent } from './components/vacations/management/management.component';

const MENU_PPAL: ISubMenu = {
  name: 'Menú principal',
  options: [
    // { icon: 'dashboard', title: 'Dashboard', link: '/home/dashboard' },
    {
      icon: 'user',
      not_svg: false,
      title: 'Usuarios',
      link: '/users',
      identifier: 'users',
      isExpandable: true,
      subsections: [
        {
          title: 'Políticas',
          identifier: 'policies',
          link: '/home/users/policies',
        },
        {
          title: 'Usuarios',
          identifier: 'users_list',
          link: '/home/users/list',
        },
      ],
    },
    {
      icon: 'web_stories',
      not_svg: true,
      title: 'Cultura empresarial',
      link: '/home/culture',
      identifier: 'company_culture',
      isExpandable: true,
      subsections: [
        {
          title: 'Historias',
          identifier: 'stories',
          link: '/home/culture/stories',
        },
        {
          title: 'Misión y visión',
          identifier: 'mission_vision',
          link: '/home/culture/mission',
        },
        {
          title: 'Organigrama',
          identifier: 'organizational_chart',
          link: '/home/culture/organization',
        },
      ],
    },
    {
      icon: 'newsmode',
      not_svg: false,
      title: 'Comunicación',
      link: '/home/communication',
      identifier: 'communication',
      isExpandable: true,
      subsections: [
        {
          title: 'Buzón',
          identifier: 'inbox',
          link: '/home/communication/mailbox',
        },
        {
          title: 'Incorporaciones',
          identifier: 'incorporations',
          link: '/home/communication/incorporation',
        },
        {
          title: 'Actividades',
          identifier: 'activities',
          link: '/home/communication/activities',
        },
        {
          title: 'Noticias',
          identifier: 'news',
          link: '/home/communication/news',
        },
        {
          title: 'Comentarios',
          identifier: 'comments',
          link: '/home/communication/comments',
        }
        
        // { title: 'Cultura empresarial', link: '/home/communication/culture' },
      ],
    },
    // { icon: 'video', title: 'Formación', link: '/training' },
    // { icon: 'restaurant', title: 'Comedor', link: '/home/dining' },
    {
      icon: 'restaurant',
      title: 'Comedor',
      link: '/home/dining',
      identifier: 'dining_room',
      isExpandable: true,
      subsections: [
        {
          title: 'General',
          identifier: 'general',
          link: '/home/dining/general',
        },
        { title: 'Precios', identifier: 'prices', link: '/home/dining/prices' },
        {
          title: 'Pantalla de cocina',
          identifier: 'kitchen_screen',
          link: '/home/dining/cook-screen',
        },
        {
          title: 'Pantalla de desayunos',
          identifier: 'kitchenbreakfast_screen',
          link: '/home/dining/cookbreakfast-screen',
        },
      ],
    },
    {
      icon: 'receipt',
      title: 'Nóminas',
      identifier: 'payrolls',
      link: '/home/payroll/manage',
      // isExpandable: true,
      // subsections: [{ title: 'Subir nóminas', link: '/home/payroll/manage' }],
    },
    {
      icon: 'event',
      title: 'Vacaciones',
      link: 'home/vacations',
      identifier: 'vacations',
      isExpandable: true,
      subsections: [
        {
          title: 'Chóferes',
          identifier: 'drivers',
          link: '/home/vacations/drivers',
        },
        {
          title: 'Vacaciones chóferes',
          identifier: 'management',
          link: '/home/vacations/management',
        },
        {
          title: 'Protocolos',
          identifier: 'protocols',
          link: '/home/vacations/protocols',
        },
        {
          title: 'Períodos de prioridad',
          identifier: 'priority_periods',
          link: '/home/vacations/priority-periods',
        },
      ],
    },
    {
      icon: 'apps',
      title: 'Utilidades',
      identifier: 'utilities',
      link: '/home/utils',
    },
    // { icon: 'more', title: 'Más opciones', link: '/more' },
  ],
};

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'home',
    component: SidemenuComponent,
    data: { menu: MENU_PPAL },
    children: [
      // {
      //   path: 'dashboard',
      //   component: DashboardComponent,
      // },
      {
        path: 'users',
        // component: UserComponent,
        children: [
          // {
          //   path: '',
          //   component: ListUsersComponent,
          // },
          // {
          //   path: 'users-edit-add',
          //   component: EditAddUserComponent,
          // },
          {
            path: 'policies',
            component: PoliciesComponent,
            children: [
              {
                path: 'edit/:id',
                component: PolicyFormComponent,
              },
              {
                path: 'add',
                component: PolicyFormComponent,
              },
            ],
          },
          {
            path: 'list',
            component: ListUsersComponent,
            children: [
              {
                path: 'edit/:id',
                component: EditUserRoleComponent,
              },
            ],
          },
        ],
      },
      {
        path: 'culture',
        children: [
          {
            path: 'stories',
            component: CultureComponent,
            children: [
              {
                path: 'edit/:id',
                component: CultureFormComponent,
              },
              {
                path: 'add',
                component: CultureFormComponent,
              },
            ],
          },
          {
            path: 'mission',
            component: MissionComponent,
            children: [
              {
                path: 'edit/:id',
                component: MissionFormComponent,
              },
              {
                path: 'add',
                component: MissionFormComponent,
              },
            ],
          },
          {
            path: 'organization',
            component: OrganizationComponent,
            children: [
              {
                path: 'edit/:id',
                component: OrganizationFormComponent,
              },
              {
                path: 'add',
                component: OrganizationFormComponent,
              },
            ],
          },
        ],
      },
      {
        path: 'communication',
        children: [
          {
            path: 'mailbox',
            component: MailboxComponent,
            children: [
              {
                path: 'edit/:id',
                component: EditDetailMailComponent,
              },
              {
                path: 'add',
                component: AddMailComponent,
              },
            ],
          },
          {
            path: 'incorporation',
            component: IncorporationFormComponent,
          },
          {
            path: 'activities',
            component: ActivitiesComponent,
            children: [
              {
                path: 'edit/:id',
                component: EditDetailActivitiesComponent,
              },
              {
                path: 'add',
                component: AddActivitiesComponent,
              },
            ],
          },
          {
            path: 'news',
            component: NewComponent,
            children: [
              {
                path: 'edit/:id',
                component: NewsFormComponent,
              },
              {
                path: 'add',
                component: NewsFormComponent,
              },
            ],
          },
          {
            path: 'comments',
            component: CommentsFormComponent,
            children: [
              {
                path: 'edit/:id',
                component: CommentsFormComponent,
              },
              {
                path: 'add',
                component: CommentsFormComponent,
              },
            ],
          },
        ],
      },
      {
        path: 'dining',
        // component: RestaurantComponent,
        children: [
          {
            path: 'general',
            component: RestaurantComponent,
            children: [
              {
                path: 'edit-date/:id',
                component: ReservationFormComponent,
              },
              {
                path: 'menu-edit',
                component: MenuEditRestaurantComponent,
              },
              {
                path: 'reservation-form',
                component: ReservationFormComponent,
              },
              {
                path: 'reservation-form/:id',
                component: ReservationFormComponent,
              },
              {
                path: 'edit-date',
                component: DatesRestaurantComponent,
              },
              {
                path: 'reservation-config',
                component: ReservationConfigComponent,
              },
            ],
          },
          {
            path: 'prices',
            component: PricesComponent,
            children: [
              {
                path: 'add',
                component: PriceFormComponent,
              },
              {
                path: 'edit/:id',
                component: PriceFormComponent,
              },
            ],
          },
          {
            path: 'cook-screen',
            component: CookScreenComponent,
            children: [
              {
                path: 'reservation-form',
                component: ReservationFormComponent,
              },
              {
                path: 'reservation-form/:id',
                component: ReservationFormComponent,
              },
              {
                path: 'edit-date/:id',
                component: ReservationFormComponent,
              },
            ],
          },
          {
            path: 'cookbreakfast-screen',
            component: CookBreakfastScreenComponent,
          },
          {
            path: 'punches',
            component: PunchesComponent,
          },
        ],
      },
      {
        path: 'payroll',
        children: [
          {
            path: '',
            redirectTo: 'manage',
            pathMatch: 'full',
          },
          {
            path: 'manage',
            component: UploadPayrollComponent,
          },
        ],
      },
      {
        path: 'vacations',
        children: [
          {
            path: 'drivers',
            component: DriversComponent,
          },
          {
            path: 'management',
            component: ManagementComponent,
          },
          {
            path: 'protocols',
            component: ProtocolsComponent,
          },
          {
            path: 'priority-periods',
            component: PriorityPeriodsComponent,
          },
          {
            path: 'priority-periods/add',
            component: PriorityPeriodFormComponent,
          },
          {
            path: 'priority-periods/:id/edit',
            component: PriorityPeriodFormComponent,
          },
          {
            path: 'protocols/protocol/add',
            component: ProtocolFormComponent,
          },
          {
            path: 'protocols/protocol/:id/edit',
            component: ProtocolFormComponent,
          },
          {
            path: 'protocols/rule-group/add',
            component: RuleGroupFormComponent,
          },
          {
            path: 'protocols/rule-group/:id/edit',
            component: RuleGroupFormComponent,
          },
          {
            path: 'protocols/rule/add',
            component: RuleFormComponent,
          },
          {
            path: 'protocols/rule/:id/edit',
            component: RuleFormComponent,
          },
          {
            path: 'drivers/exercise/add',
            component: ExerciseFormComponent,
          },
          {
            path: 'drivers/protocol/add',
            component: ProtocolFormComponent,
          },
          {
            path: 'drivers/exercise/:id/:year',
            component: ExerciseComponent,
          },
          {
            path: 'drivers/exercise/:id/:year/edit',
            component: ExerciseFormComponent,
          },
          {
            path: 'drivers/exercise/:id/:year/operational/:opId',
            component: OperationalComponent,
          },
          {
            path: 'drivers/exercise/:id/:year/operational/:opId/edit',
            component: OperationalFormComponent,
          },
          {
            path: 'drivers/exercise/:id/:year/operational/:opId/edit-holidays',
            component: OperationalFormComponent,
          },
          {
            path: 'drivers/exercise/:id/:year/operational/:opId/protocol/:protocolId/edit',
            component: ProtocolFormComponent,
          },
          {
            path: 'drivers/exercise/:id/:year/operational/:opId/driver/:driverId',
            component: DriverProfileComponent,
          },
          {
            path: 'management/exercise/:id/:year',
            component: DriversvacationsComponent,
          },
        ],
      },
      {
        path: 'reservation-config',
        component: ReservationConfigComponent,
      },
      {
        path: 'shipment-configuration',
        component: ShipmentConfigurationComponent,
      },
      {
        path: 'upload',
        component: UploadFilesComponent,
      },
      {
        path: 'utils',
        component: UtilsComponent,
      },
    ],
  },
];
